<template>
	<div class="statistica__per-month-wrap">
		<div v-for = "(item,index) in weekSum.week" :key="index">
            <div class="statistica__per-month-title">{{item[item.length -1].title}}-я Торговая неделя
                <span>/ {{item[0].dateFormat}} - {{item[item.length -2].dateFormat}} </span>
                <div class="statistica__per-month-summaryProfit">
                    <div>Доход</div>
                    <div :class = "((item[item.length - 1].profitAbs < 0) ? 'color-red' : 'color-green')">$ {{$moneyf(item[item.length - 1].profitAbs)}}</div>
                    <div :class = "((item[item.length - 1].profitRel < 0) ? 'color-red' : 'color-green')">% {{(item[item.length - 1].profitRel).toFixed(2)}}</div>
                </div>
            </div>
            <div class="statistica__per-month">
                <div class="statistica__per-month-row">
                    <div class="statistica__per-month-item-data_wrap">
                        <!--<div v-for = "(day, number) in item" :key="number + 'day'" v-if="day.title" class="statistica__per-month-item">
                            <div class="statistica__per-month-item-title">
                                <div class="statistica__per-month-item-title-day">{{day.title}}-я неделя</div>
                                <div class="statistica__per-month-item-title-date"></div>
                            </div>
                            <div class="statistica__per-month-item-data">
                                <div class="statistica__per-month-item-data-sum"
                                    :class = "((day.profitAbs < 0) ? 'color-red' : 'color-green')">$ {{day.profitAbs}}</div>
                                <div class="statistica__per-month-item-data-pips"
                                    :class = "((day.profitRel < 0) ? 'color-red' : 'color-green')">{{(day.profitRel).toFixed(2)}}%</div>
                                <div class="statistica__per-month-item-data-probability">{{(day.equityOnEod).toLocaleString('ru')}}</div>
                                <div class="statistica__per-month-item-data-maxdd">Max. DD {{(day.maxDd).toFixed(2)}}</div>
                            </div>
                        </div>-->
                        <div v-for = "(day, number) in item" :key="number + 'day'" v-if="!day.title" class="statistica__per-month-item">
                            <div class="statistica__per-month-item-title">
                                <div class="statistica__per-month-item-title-day">{{day.weekDayName}}</div>
                                <div class="statistica__per-month-item-title-date">{{day.dateFormat}}</div>
                            </div>
                            <div class="statistica__per-month-item-data">
                                <div class="statistica__per-month-item-data-sum"
                                    :class = "((day.profitAbs < 0) ? 'color-red' : 'color-green')">$ {{day.profitAbs}}</div>
                                <div class="statistica__per-month-item-data-pips"
                                    :class = "((day.profitRel < 0) ? 'color-red' : 'color-green')">{{(day.profitRel).toFixed(2)}}%</div>
                                <div class="statistica__per-month-item-data-probability">{{(day.equityOnEod).toLocaleString('ru')}}</div>
                                <div class="statistica__per-month-item-data-maxdd">Max. DD {{(day.maxDd).toFixed(2)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="statistica__per-month-item-chart" style="min-height: 100%;">
                        <week-chart
                        :week="index"
                        ></week-chart>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import WeekChart from './sig-profitability-static-of-month-chart';
export default {
	components: {
        'week-chart':WeekChart,
    },
	props: {
		symbol: { default: '' }
	},
	data() {
		return {
            weekSum: null,
            loading:true
		};
	},
	computed: {
		...mapGetters({
              getMonthStat: 'accountstat/getMonthStat',
        }),

	},
	methods: {
		setData() {
            let stat = this.getMonthStat('');
            if (!stat) {
                return;
            }
            this.weekSum = stat;
        }
	},
	created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
                this.setData();
        });
        this.setData();
    } // created }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-month",
            handler: handler
        }
    });
}
</script>

<style lang="less" scoped>
.statistica__per-month {
    background: #3d536b;
    border-radius: 0px 0px 4px 4px;
    height: 800px;
    &-wrap {
        display: block;
        min-height: 100%;
        z-index: 2;
    }
    &-preloader {
        display: flex;
        width: 100%;
        justify-content: center;
        height: calc(100vh - 291px);
        align-items: center;
    }
    &-title {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        margin-top: 12px;
        line-height: 3.08;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #ffffff;
        padding-left: 12px;
        background: #3d536b;
        border-radius: 4px 4px 0px 0px;
        border-bottom: 1px solid #374b62;
        display: flex;
        span {
            font-weight: normal;
            color: #aabed2;
        }
    }

    &-summaryProfit {
        display: flex;
        margin-left: 12px;

        div {
            margin-right: 12px;
        }
    }

    &-row {
        display: flex;
        //justify-content: space-between;
        min-height: 100%;
        max-width: 100%;
        overflow: hidden;
    }

    &-item {
        width: 170px;
        height: 160px;
        border-bottom: 1px solid #374b62;
        flex-grow: 1;
        box-sizing: border-box;

        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 10px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 12px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 10px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-right: 12px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &_wrap {
                border-right: 1px solid #374b62;
            }

            &-sum {
                font-family: Arimo;
                font-size: 16px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 16px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 10px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: @colors[red];
                }
        }

        &-chart {
            display: flex;
            flex-grow: 1;
            min-height: 100%;

        }
    }
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 51px;
    height: 51px;
    margin: 6px;
    border: 6px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
}
</style>
